import { Button, Card, Form, Input, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd";
import SecretText from "../SecretText";

type SmsCredentialsPanelProps = {
  mode: "tenant" | "admin";
  group: any;
  form: FormInstance;
  formData: any;
  formDisabled: boolean;
  layout: object;
  tailLayout: object;
  onToggleEdit?: () => void;
  onValuesChange: () => void;
  onSubmit: (values: any) => void;
};

const SmsCredentialsPanel: React.FC<SmsCredentialsPanelProps> = ({
  mode,
  group,
  form,
  formData,
  formDisabled,
  layout,
  tailLayout,
  onToggleEdit,
  onValuesChange,
  onSubmit,
}) => {
  if (mode === "tenant") {
    return (
      <Card
        title="SMS Credentials"
        style={{ backgroundColor: "#DCDCDC" }}
        bordered
        hoverable
      >
        <div className="card-content">
          <h4>SMS Api Key:</h4>
          <SecretText value={group.SmsApiKey} />
        </div>
        <div className="card-content">
          <h4>SMS Api Secret:</h4>
          <SecretText value={group.SmsApiSecret} />
        </div>
      </Card>
    );
  }

  return (
    <Card
      title="SMS Credentials"
      bordered
      hoverable
      extra={
        onToggleEdit ? (
          <EditOutlined onClick={onToggleEdit} style={{ color: "blue" }} />
        ) : null
      }
    >
      <Form
        {...layout}
        onFinish={onSubmit}
        initialValues={formData}
        disabled={formDisabled}
        form={form}
        onValuesChange={onValuesChange}
      >
        <div className="card-content">
          <Form.Item
            name="SmsApiKey"
            label="SMS API Key"
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder="SMS API Key" />
          </Form.Item>
        </div>
        <div className="card-content">
          <Form.Item
            name="SmsApiSecret"
            label="SMS API Secret"
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder="SMS API Secret" />
          </Form.Item>
        </div>
        {!formDisabled && (
          <div className="card-content">
            <Form.Item {...tailLayout}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button
                  style={{ marginBottom: 10 }}
                  block
                  size="large"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </div>
        )}
      </Form>
    </Card>
  );
};

export default SmsCredentialsPanel;
